import React from 'react';
import { IoLogoInstagram, IoLogoFacebook, IoLogoWhatsapp } from "react-icons/io";
import './footer.css';
import { assets } from '../../assets/assets';
import { Link } from 'react-router-dom';

const Footer = () => {
  const handleWhatsappClick = () => {
    window.open(`https://wa.me/5571999556884`, '_blank');
  };

  const emailTrinco = "contato@trincoservicos.com.br";

  return (
    <footer className="footer-wrapper">
      <div className="footer-container">

        {/* Lado Esquerdo: Logo e Resumo */}
        <div className="footer-brand">
          <img className='footer-logo' src={assets.Logo} alt="Trinco Logo" />
        </div>

        {/* Centro: Contatos Rápidos */}
        <div className="footer-contact-info">
          <div className="contact-row">
            <span>{emailTrinco}</span>
            <span className="separator">|</span>
            <span>(71) 99955-6884</span>
          </div>
          <p className="working-hours">Funcionamento conforme horário do shopping.</p>
        </div>

        {/* Lado Direito: Redes Sociais */}
        <div className="footer-social">
          <Link to="https://www.instagram.com/trincoservicos" target="_blank" rel="noopener noreferrer" className="social-icon">
            <IoLogoInstagram />
          </Link>
          <Link to="https://www.facebook.com/natrincotem" target="_blank" rel="noopener noreferrer" className="social-icon">
            <IoLogoFacebook />
          </Link>
          <button onClick={handleWhatsappClick} className="social-icon whatsapp-btn">
            <IoLogoWhatsapp />
          </button>
        </div>

      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} TRINCO - Todos os direitos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;